import { getBirthDateString, sanitizePhoneNumber, sanitizeText, } from "../utils/index.js";
import { getAddressesFromInput } from "../utils/getAddressesFromInput.js";
export const selectUpdateCustomerInput = (customerInput) => {
    const { phone, firstName, lastName, email, addresses, externalReferences, birthDate, ...customer } = customerInput;
    const trimmedPhone = phone?.trim();
    const phoneProvided = "phone" in customerInput;
    // When phone is part of the input we own its external reference: drop any
    // existing "phone" ref, then re-add it only if a value was given.
    const baseRefs = externalReferences ?? [];
    const refs = phoneProvided
        ? [
            ...baseRefs.filter((ref) => ref.key !== "phone"),
            ...(trimmedPhone
                ? [{ key: "phone", value: sanitizePhoneNumber(trimmedPhone) }]
                : []),
        ]
        : baseRefs;
    const shouldSendRefs = externalReferences != null || refs.length > 0;
    return {
        ...customer,
        birthDate: birthDate === ""
            ? null
            : birthDate
                ? getBirthDateString(birthDate)
                : undefined,
        phone: trimmedPhone
            ? sanitizePhoneNumber(trimmedPhone)
            : phone === ""
                ? null
                : undefined,
        firstName: firstName ? sanitizeText(firstName) : undefined,
        lastName: lastName ? sanitizeText(lastName) : undefined,
        addresses: addresses
            ? getAddressesFromInput(addresses, email ?? undefined)
            : undefined,
        email: email === "" ? null : email ? sanitizeText(email) : undefined,
        externalReferences: shouldSendRefs ? refs : undefined,
    };
};
